export default __webpack_public_path__ + "static/media/bg2.063c37e1.png";